// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__simulatorRigsContainer--S8tnR {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.style__tabsContainer--XFGdB {
  flex: 1;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.style__container--cO6Tz {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.style__header--sNbIy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.style__headerInfo--ltgZY {
  display: flex;
  gap: 1rem;
  align-items: center;
  align-self: stretch;
}
.style__tags--yChBv {
  display: flex;
  gap: 1rem;
  align-items: center;
  align-self: stretch;
  flex-wrap: wrap;
}
.style__icon--gzpaJ {
  color: #7d8287;
  cursor: pointer;
}
.style__healthStatusBanner--PNgKw {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  border-radius: 8px;
  border: 1px solid #313235;
  background: #0c0d0d;
}
.style__healthStatusLarge--Ut0Lb [aria-label='badge'] {
  padding: 1rem 1.5rem;
}
.style__deviceInfoContainer--lCjf5 {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
  min-height: 0;
  overflow: auto;
  padding-top: 1rem;
}
.style__snapshotSection--fa_8R, .style__checksSection--ZiQWf {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__checkSection--LNg3j {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid #313235;
  border-radius: 8px;
  background: #fff;
}
.style__dynamicSection--NZlgD {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__nestedBlock--DdKTj {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 1rem;
  border-left: 2px solid #313235;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SimulatorRigsPage/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAHJ;AAFA;EASI,OAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAJJ;AARA;EAgBI,aAAA;EACA,sBAAA;EACA,WAAA;AALJ;AAbA;EAsBI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAnBA;EA6BI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AAzBA;EAoCI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AARJ;AAhCA;EA4CI,cAAA;EACA,eAAA;AATJ;AApCA;EAiDI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAVJ;AA7CA;EA6DQ,oBAAA;AAbR;AAhDA;EAmEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAhBJ;AAzDA;EA8EI,aAAA;EACA,sBAAA;EACA,SAAA;AAjBJ;AA/DA;EAoFI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAlBJ;AAxEA;EA8FI,aAAA;EACA,sBAAA;EACA,SAAA;AAnBJ;AA7EA;EAoGI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AApBJ","sourcesContent":["@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/colors';\n\n:local {\n  .simulatorRigsContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .tabsContainer {\n    flex: 1;\n    height: 100%;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-150;\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  .headerInfo {\n    display: flex;\n    gap: @spacing-100;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  .tags {\n    display: flex;\n    gap: @spacing-100;\n    align-items: center;\n    align-self: stretch;\n    flex-wrap: wrap;\n  }\n\n  .icon {\n    color: @color-asphalt-grey-050;\n    cursor: pointer;\n  }\n\n  .healthStatusBanner {\n    display: flex;\n    align-items: center;\n    gap: @spacing-100;\n    padding: @spacing-150 @spacing-200;\n    border-radius: 8px;\n    border: 1px solid @color-asphalt-grey-020;\n    background: @color-asphalt-grey-005;\n  }\n\n  .healthStatusLarge {\n    :global {\n      [aria-label='badge'] {\n        padding: @spacing-100 @spacing-150;\n      }\n    }\n  }\n\n  .deviceInfoContainer {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-200;\n    height: 100%;\n    min-height: 0;\n    overflow: auto;\n    padding-top: @spacing-100;\n  }\n\n  .snapshotSection,\n  .checksSection {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .checkSection {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    padding: @spacing-150;\n    border: 1px solid @color-asphalt-grey-020;\n    border-radius: 8px;\n    background: @color-white;\n  }\n\n  .dynamicSection {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .nestedBlock {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    padding-left: @spacing-100;\n    border-left: 2px solid @color-asphalt-grey-020;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"simulatorRigsContainer": `style__simulatorRigsContainer--S8tnR`,
	"tabsContainer": `style__tabsContainer--XFGdB`,
	"container": `style__container--cO6Tz`,
	"header": `style__header--sNbIy`,
	"headerInfo": `style__headerInfo--ltgZY`,
	"tags": `style__tags--yChBv`,
	"icon": `style__icon--gzpaJ`,
	"healthStatusBanner": `style__healthStatusBanner--PNgKw`,
	"healthStatusLarge": `style__healthStatusLarge--Ut0Lb`,
	"deviceInfoContainer": `style__deviceInfoContainer--lCjf5`,
	"snapshotSection": `style__snapshotSection--fa_8R`,
	"checksSection": `style__checksSection--ZiQWf`,
	"checkSection": `style__checkSection--LNg3j`,
	"dynamicSection": `style__dynamicSection--NZlgD`,
	"nestedBlock": `style__nestedBlock--DdKTj`
};
export default ___CSS_LOADER_EXPORT___;
